/**
 * Implements current client-side project filtering rules, returning
 * true/false depending on if the given project fits the criteria.
 * Currently only project name and guid are considered.
 * 
 * @param {string} searchString - search term provided by the user
 * @param {object} project - project to check against
 */

// TODO: unit tests

function projectFitsSearchCriteria(searchString, project) {
  if (!project) return false;

  const searchStringLower = searchString ? searchString.toLowerCase().trim() : '';
  if (!searchStringLower) return true;

  const projectNameLower = (project.name || '').toLowerCase();

  if (project.guid && project.guid.toLowerCase().startsWith(searchStringLower)) return true;
  if (projectNameLower.startsWith(searchStringLower)) return true;
  // match when search appears anywhere in the name (e.g. "new" matches "000NewTest")
  if (projectNameLower.includes(searchStringLower)) return true;
  // check individual project name words
  const projectWords = projectNameLower.split(/\s+/);
  for (let projectWord of projectWords) {
    if (projectWord.startsWith(searchStringLower)) return true;
  }
  return false;
}

function locationFitsSearchCriteria(searchString, location) {
  if (!location) return false;

  const searchStringLower = searchString ? searchString.toLowerCase() : '';
  const locationNameLower = location.name.toLowerCase();
  
  if (location.guid.toLowerCase().startsWith(searchStringLower) || locationNameLower.startsWith(searchStringLower)) {
    return true;
  }
  else {
    // check individual location name words
    const locationWords = locationNameLower.split(' ');
    for (let locationWord of locationWords) {
      if (locationWord.startsWith(searchStringLower)) {
        return true;
      }
    }
  }
  return false;
}

export default {
  projectFitsSearchCriteria,
  locationFitsSearchCriteria,
};



// WEBPACK FOOTER //
// ./src/helpers/search/ClientSearchHelper.js